import React, { useEffect, useState } from "react";
import axios from "axios";
import customerService from "../assets/img/ask_a_question.jpg";
import { API_END_POINTS } from "../API_END_POINTS";
import { toast } from "react-toastify";
import { submitQuestion } from "../redux/features/footerPages/footerPagesContentSlice";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const AskQuestions = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { loading, success, error } = useSelector(
    (state) => state.footerPagesContent
  );
  const { categories } = useSelector((state) => state.categories);

  // Separate state for each field
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [category, setCategory] = useState("");
  const [question, setQuestion] = useState("");
  const [agree, setAgree] = useState(false);
  const [profileImage, setProfileImage] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    switch (name) {
      case "name":
        setName(value);
        break;
      case "email":
        setEmail(value);
        break;
      case "phone":
        setPhone(value);
        break;
      case "category":
        setCategory(value);
        break;
      case "question":
        setQuestion(value);
        break;
      case "agree":
        setAgree(checked);
        break;
      default:
        break;
    }
  };

  const handleFileChange = (e) => {
    setProfileImage(e.target.files[0]);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("name", name);
    formData.append("email", email);
    formData.append("phone", phone);
    formData.append("category", category);
    formData.append("question", question);
    if (profileImage) formData.append("image", profileImage);

    dispatch(submitQuestion(formData));
  };

  useEffect(() => {
    if (success) {
      toast.success(`${t("Your_question_has_been_submitted_successfully!")}`, {
        hideProgressBar: true,
        position: "bottom-right",
        theme: "dark",
        theme: "dark",
      });

      setName("");
      setEmail("");
      setPhone("");
      setCategory("");
      setQuestion("");
      setProfileImage(null);
    }
    if (error) {
      toast.error(error.message, {
        hideProgressBar: true,
        position: "bottom-right",
        theme: "dark",
        theme: "dark",
      });
    }
  }, [success, error]);

  return (
    <>
      <div className="container-fluid faq-heading">
        <div className="row">
          <h1 className="text-center">{`${t("Ask-a-Question")}`}</h1>
          <p className="text-center">{`${t("We’re_here_to_help!")}`}</p>
        </div>
      </div>
      <div className="container my-5">
        <div className="row align-items-center g-4">
          {/* Right Side Image */}
          <div className="col-12 col-md-6 order-1 order-md-2 text-center">
            <div className="p-4 bg-light rounded">
              <img
                src={customerService}
                alt="Ask Question Illustration"
                className="img-fluid mb-3"
                style={{ maxHeight: "320px", objectFit: "contain" }}
              />
              <h5 className="fw-bold">{`${t("We_are_here")}`}</h5>
              <p className="text-muted mb-0">{`${t("Submit_your")}`}</p>
            </div>
          </div>

          {/* Left Side Form */}
          <div className="col-12 col-md-6 order-2 order-md-1">
            <form
              className="p-4 shadow-sm rounded bg-white"
              onSubmit={handleSubmit}
            >
              <div className="row g-3">
                <div className="col-12 col-md-6">
                  <label className="form-label fw-bold">{`${t("Name")}`}</label>
                  <input
                    type="text"
                    className="form-control"
                    name="name"
                    value={name}
                    onChange={handleChange}
                    placeholder={`${t("Enter_Your_Name_Here")}`}
                    required
                  />
                </div>

                <div className="col-12 col-md-6">
                  <label className="form-label fw-bold">{`${t(
                    "Email"
                  )}`}</label>
                  <input
                    type="email"
                    className="form-control"
                    name="email"
                    value={email}
                    onChange={handleChange}
                    placeholder={`${t("Enter_Your_Email_Here")}`}
                    required
                  />
                </div>

                <div className="col-12 col-md-6">
                  <label className="form-label fw-bold">{`${t(
                    "Phone"
                  )}`}</label>
                  <input
                    type="text"
                    className="form-control"
                    name="phone"
                    value={phone}
                    onChange={(e) => {
                      const value = e.target.value.replace(/\D/g, ""); // only digits
                      handleChange({ target: { name: "phone", value } });
                    }}
                    placeholder={`${t("Enter_your_phone")}`}
                  />
                </div>

                <div className="col-12 col-md-6">
                  <label className="form-label fw-bold">{t("Category")}</label>

                  <div className="dropdown w-100">
                    <button
                      className="form-select text-start"
                      type="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      {category || t("Select_a_Category")}
                    </button>

                    <ul
                      className="dropdown-menu w-100"
                      style={{ maxHeight: "200px", overflowY: "auto" }}
                    >
                      {categories.map((cat, index) => (
                        <li key={index}>
                          <button
                            className="dropdown-item"
                            onClick={() =>
                              handleChange({
                                target: { name: "category", value: cat.title },
                              })
                            }
                          >
                            {cat.title}
                          </button>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>

                <div className="col-12">
                  <label className="form-label fw-bold">
                    {`${t("Attach_File")}`}
                  </label>
                  <input
                    type="file"
                    className="form-control"
                    name="attachment"
                    onChange={handleFileChange}
                  />
                </div>

                <div className="col-12">
                  <label className="form-label fw-bold">
                    {`${t("Question")}`}
                  </label>
                  <textarea
                    className="form-control"
                    name="question"
                    value={question}
                    onChange={handleChange}
                    rows="4"
                    placeholder={`${t("Type_your_question")}`}
                    required
                  ></textarea>
                </div>

                <div className="col-12 d-flex align-items-center justify-content-start">
                  <input
                    type="checkbox"
                    className="form-check-input m-0 me-2"
                    id="agree"
                    name="agree"
                    checked={agree}
                    onChange={handleChange}
                    required
                  />
                  <label className="form-check-label" htmlFor="agree">
                    {`${t("I_agree")}`}
                  </label>
                </div>

                <div className="col-12">
                  <button
                    className="btn btn-primary w-100 py-2 fw-bold"
                    type="submit"
                    disabled={loading}
                  >
                    {loading ? `${t("Submitting")}` : `${t("Submit")}`}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default AskQuestions;
